var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDueInActiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2059_12",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4F4F4F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2059_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6702 9.81897C18.568 9.79956 20.9807 12.1605 21.0065 15.0518C21.0324 18.0078 18.6456 20.4269 15.7025 20.4399C12.8112 20.4528 10.4115 18.0725 10.3986 15.1747C10.3792 12.2187 12.7207 9.83837 15.6702 9.8125V9.81897Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62586 9.00373C6.98938 8.92611 5.41113 8.68678 3.94283 7.94293C3.5418 7.73594 3.1537 7.46428 2.83675 7.14086C2.24814 6.54578 2.28048 5.96364 2.8691 5.36209C3.41243 4.79935 4.09807 4.463 4.82251 4.23014C7.52625 3.35692 10.2171 3.36986 12.869 4.41772C13.3736 4.61824 13.8587 4.93518 14.2727 5.28447C14.9906 5.89249 14.9777 6.59753 14.2921 7.24436C13.4965 8.00114 12.4939 8.3763 11.446 8.58976C10.5146 8.7838 9.56376 8.86142 8.61939 8.99726L8.62586 9.00373Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1409 10.633C9.81097 11.2151 9.51343 11.7649 9.19649 12.3018C9.15121 12.3729 9.04125 12.4506 8.95716 12.457C7.19779 12.4958 5.49017 12.2694 3.89897 11.4609C3.60143 11.3057 3.31683 11.1181 3.0581 10.9046C2.45655 10.3936 2.33365 9.99261 2.45655 9.1582C4.84334 10.5748 7.44358 10.84 10.1344 10.6394L10.1409 10.633Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0505 19.4758C9.60418 19.5017 9.19021 19.547 8.76977 19.547C7.23679 19.547 5.72968 19.3594 4.31313 18.7385C3.95091 18.5768 3.60809 18.3698 3.27174 18.1563C2.59257 17.71 2.27563 17.089 2.4438 16.2676C2.93539 16.5004 3.42051 16.7656 3.9315 16.9662C5.48389 17.5742 7.10096 17.807 8.75683 17.7682C9.02203 17.7682 9.1514 17.8394 9.2743 18.0916C9.49422 18.5573 9.76588 18.9907 10.044 19.4823L10.0505 19.4758Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45847 12.6842C4.36661 13.8485 6.45586 14.2107 8.63567 14.2366V16.0089C7.67837 16.0089 6.74047 15.9119 5.80904 15.6855C4.89701 15.472 4.03026 15.1551 3.26054 14.6053C2.60077 14.1396 2.27736 13.5315 2.45847 12.6777V12.6842Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDueInActiveIcon);
export default __webpack_public_path__ + "static/media/Payment-Due-InActive-Icon.c5fc31bd1610a4a33a5e5e4a2da103a7.svg";
export { ForwardRef as ReactComponent };